"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnPauseButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_material_1 = require("@mui/icons-material");
const react_hooks_eth_1 = require("@dzambalaorg/react-hooks-eth");
const styled_1 = require("@framework/styled");
const types_1 = require("@framework/types");
const unpause_json_1 = __importDefault(require("@framework/abis/json/Pausable/unpause.json"));
const utils_1 = require("../../../utils");
const UnPauseButton = (props) => {
    const { className, contract, contract: { address, isPaused, contractFeatures, accessControls }, disabled, variant, } = props;
    const { writeContractAsync } = (0, react_hooks_eth_1.useWriteContractWithSimulation)();
    const hasPermission = accessControls.some(item => item.role === types_1.AccessControlRoleType.PAUSER_ROLE);
    const { execute: metaUnPause } = (0, react_hooks_eth_1.useMetamask)(async () => {
        return writeContractAsync({
            address: address,
            abi: unpause_json_1.default,
            functionName: "unpause",
        });
    });
    const handleUnPause = () => {
        return metaUnPause();
    };
    if (!contractFeatures.includes(types_1.ContractFeatures.PAUSABLE) || !isPaused) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleUnPause, icon: icons_material_1.PlayCircleOutline, message: "form.buttons.unpause", className: className, dataTestId: "UnPauseButton", disabled: disabled || (0, utils_1.shouldDisableByContractType)(contract) || !hasPermission, variant: variant }));
};
exports.UnPauseButton = UnPauseButton;
//# sourceMappingURL=index.js.map